import { Grid, Paper } from '@material-ui/core';

export const ViewerComponent = ({ children }) => {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={8}>
        <Paper elevation={2}>
          {children}
        </Paper>
      </Grid>
    </Grid>
  );
}